// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BM-z","twoColumnImage":"CM-z"};